import React, { FC, SetStateAction, useState } from 'react';

interface IOrdermadeModalProps {
    show: boolean;
    setShow: React.Dispatch<SetStateAction<boolean>>;
}

export const Modal: FC<IOrdermadeModalProps> = (props) => {
    const { show, children } = props;

    if (show === false) {
        return null;
    }

    return (
        <div className="Modal">
            <div className="modal_overlay">
                <div className="content">
                    {children}
                </div>
            </div>
        </div>
    );
};

interface IOrdermadeModal {
    status: boolean;
}

export const OrdermadeModal: FC<IOrdermadeModal> = (props) => {
    const { status } = props;

    const [show, setShow] = useState<boolean>(status);

    return (
        <Modal show={show} setShow={setShow}>
            <div className="ordermade_modal">
                <h1>はじめに</h1>
                <p>
                    0からデザインを始める場合は、はじめにシャフトを選択するところから始めていただきます。
                </p>
                <button type="button" onClick={() => setShow(false)}>次へ →</button>
            </div>
        </Modal>
    );
};
